import { V3Record } from 'data/helpers/V3Record.js'

export const SiteActivity = V3Record('siteActivity', {
  userId: null,
  name: null,
  action: null,
  performedAt: null,
  path: null,
  actionableItemId: null,
  actionableItemType: null,
  createdAt: null,
  updatedAt: null
})
